// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__2fttD","dragIcon":"Choice_dragIcon__2KSFq","left":"Choice_left__34A4h","input":"Choice_input__397Mx"};